
import { Component, Vue } from 'vue-property-decorator';
import { fundListForAuthCommon, queryFundListForAuth } from '@/api/finance.js';
import authConfig from '@/components/finance/authConfig.vue';
import { chineseCurrencyMap, fundTypeMap, fundAuthListColumns } from '@/utils/finance';

interface SelectItem {
  value: number;
  name: string;
}

@Component({
  components: { authConfig }
})
class FundAuthList extends Vue {
  searchParams = {
    currency: null,
    type: null,
    financePeopleId: null,
    searchName: ''
  };
  currencyList: SelectItem[] = [];
  typeList: SelectItem[] = [];
  financePeopleList: any[] = [];
  tableColumns = fundAuthListColumns;
  dataList: object[] = [];
  total: number = 0;
  authProject: any = null;
  authConfigVisible = false;
  async mounted() {
    this.fetchFinancePeople();
    this.fetchFundList();
  }

  async fetchFinancePeople() {
    fundListForAuthCommon().then(res => {
      this.financePeopleList = ((res.data && res.data.financePeopleList) || []).map(_ => ({ name: _.name, value: _.id }));
    });
  }

  async fetchFundList() {
    try {
      let res = await queryFundListForAuth(this.searchParams);
      let { data = [] } = res || {};
      this.dataList = data;
    } catch (e) {}
  }

  selectChange(key) {
    return val => {
      this.searchParams[key] = val;
      this.fetchFundList();
    };
  }

  inputSearch(val) {
    this.searchParams.searchName = val;
    this.fetchFundList();
  }

  toFMV(id) {
    window.open(`/finance/fairvalueTable?fundId=${id}`);
  }

  auth(project) {
    this.authProject = project;
    this.authConfigVisible = true;
  }

  hideAuthConfig() {
    this.authConfigVisible = false;
  }

  render() {
    let {
      tableColumns,
      dataList,
      financePeopleList,
      selectChange,
      inputSearch,
      toFMV,
      total,
      auth,
      authConfigVisible,
      hideAuthConfig,
      authProject,
      fetchFundList
    } = this;
    let selectList = [
      {
        key: 'currency',
        list: Object.keys(chineseCurrencyMap).map(_ => ({ value: _, name: chineseCurrencyMap[_] })),
        name: '基金币种'
      },
      {
        key: 'type',
        list: Object.keys(fundTypeMap)
          .filter(_ => +_ !== 2)
          .map(_ => ({ value: _, name: fundTypeMap[_] })),
        name: '基金类别'
      },
      {
        key: 'financePeopleId',
        list: financePeopleList,
        name: '财务负责人'
      }
    ];
    return (
      <div>
        <a-breadcrumb>
          <a-breadcrumb-item>财务管理</a-breadcrumb-item>
          <a-breadcrumb-item>基金授权列表</a-breadcrumb-item>
        </a-breadcrumb>
        <a-row class="search-bar">
          {selectList.map(selectItem => (
            <a-col span="4">
              <a-select placeholder={selectItem.name} onChange={selectChange(selectItem.key)} class="select" allowClear>
                {selectItem.list.map(item => (
                  <a-select-option value={item.value}>{item.name}</a-select-option>
                ))}
              </a-select>
            </a-col>
          ))}
          <a-col span="12" class="search-container">
            <a-input-search placeholder="搜索项目简称/名称" onSearch={inputSearch} class="input-search" />
          </a-col>
        </a-row>
        <div>
          <a-table
            columns={tableColumns}
            data-source={dataList}
            bordered
            scopedSlots={{
              action: fund => (
                <div class="btns">
                  <a-button  data-ga-id="北冥-基金授权列表-点击进入" size="small" type="primary" onClick={toFMV.bind(this, fund.fundId)}>
                    进入
                  </a-button>
                  {fund.canAuth ? (
                    <a-button  data-ga-id="北冥-基金授权列表-点击权限" size="small" type="primary" onClick={auth.bind(this, fund)}>
                      权限
                    </a-button>
                  ) : (
                    ''
                  )}
                </div>
              )
            }}
            pagination={false}
          />
        </div>
        {authConfigVisible ? (
          <auth-config visible={this.authConfigVisible} onHide={hideAuthConfig} onRefresh={fetchFundList} project={authProject} type="fund"></auth-config>
        ) : (
          ''
        )}
      </div>
    );
  }
}
export default FundAuthList;
